import React, { Component } from 'react';
import Header from '../../layout/header/header'
import Footer from '../../layout/footer/footer'
import blogimg11 from '../../assets/blog-img11.png'
import timg from '../../assets/t-img.png'

import '../about-us/aboutUs.css';
class aboutUs extends Component {
    render() {
        return (
            <div>
                <Header/>
    {/* <!-- about us start --> */}
    <div className="about_us">
        <div className="container-fluid">
            <div className="about_design">
              <h2>Who we are?</h2>
              <div className="row align-items-center">
                <div className="col-md-4">
                    <img className="img-fluid" src={blogimg11} alt="img" />
                </div>
                <div className="col-md-8">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. eiusmod tempor incididunt ut labore et dolore magna aliqua. labore et dolore mikm ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, psum dolor sit amet, consectetur adipiscing elit,</p>
                </div>
              </div>
            </div>
            <div className="about_design">
              <h2>What do we do?</h2>
              <div className="row align-items-center">
                <div className="col-md-8">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. eiusmod tempor incididunt ut labore et dolore magna aliqua. labore et dolore mikm ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, psum dolor sit amet, consectetur adipiscing elit,</p>
                </div>
                <div className="col-md-4">
                    <img className="img-fluid" src={blogimg11} alt="img" />
                </div>
              </div>
            </div>
            <div className="our_team">
              <h2>Our Team</h2>
              <div className="row">
                <div className="col-sm-6">
                  <div className="card_main">
                    <div className="card_head d-flex align-items-center">
                      <img className="img-fluid" src={timg} alt="" />
                      <div>
                        <h3>Nitish paul</h3>
                        <button className="btn">Connect on linkedIn<i className="fa fa-linkedin-square ml-2" aria-hidden="true"></i></button>
                      </div>
                    </div>
                    <p>The lorem ipsum gets its name from the Latin phrase Neque porro quisquam 
                      est qui dolorem ipsum The lorem ipsum gets its name 
                      from the Latin phrase Neque porro quisquam est qui dolorem ipsum 
                    </p>
                  </div>

                </div>
                <div className="col-sm-6">
                  <div className="card_main">
                    <div className="card_head d-flex align-items-center">
                      <img className="img-fluid" src={timg} alt="" />
                      <div>
                        <h3>Nitish paul</h3>
                        <button className="btn">Connect on linkedIn<i className="fa fa-linkedin-square ml-2" aria-hidden="true"></i></button>
                      </div>
                    </div>
                    <p>The lorem ipsum gets its name from the Latin phrase Neque porro quisquam 
                      est qui dolorem ipsum The lorem ipsum gets its name 
                      from the Latin phrase Neque porro quisquam est qui dolorem ipsum 
                    </p>
                  </div>

                </div>
                <div className="col-sm-6">
                  <div className="card_main">
                    <div className="card_head d-flex align-items-center">
                      <img className="img-fluid" src={timg} alt="" />
                      <div>
                        <h3>Nitish paul</h3>
                        <button className="btn">Connect on linkedIn<i className="fa fa-linkedin-square ml-2" aria-hidden="true"></i></button>
                      </div>
                    </div>
                    <p>The lorem ipsum gets its name from the Latin phrase Neque porro quisquam 
                      est qui dolorem ipsum The lorem ipsum gets its name 
                      from the Latin phrase Neque porro quisquam est qui dolorem ipsum 
                    </p>
                  </div>

                </div>
                <div className="col-sm-6">
                  <div className="card_main">
                    <div className="card_head d-flex align-items-center">
                      <img className="img-fluid" src={timg} alt="" />
                      <div>
                        <h3>Nitish paul</h3>
                        <button className="btn">Connect on linkedIn<i className="fa fa-linkedin-square ml-2" aria-hidden="true"></i></button>
                      </div>
                    </div>
                    <p>The lorem ipsum gets its name from the Latin phrase Neque porro quisquam 
                      est qui dolorem ipsum The lorem ipsum gets its name 
                      from the Latin phrase Neque porro quisquam est qui dolorem ipsum 
                    </p>
                  </div>

                </div>
              </div>
            </div>
        </div>

    </div>

    {/* <!-- about us end --> */}
    <Footer/>

            </div>
        );
    }
}

export default aboutUs;
